import { storage } from '../../utils'
import React, { Component, PropTypes } from 'react'
import { Link, browserHistory } from 'react-router'
import Dialog from '../dialog'
import { formHandler, TextInput, Select, Button } from '../ui'

export default class SignUp extends Component {
    static displayName = 'SignUp'

    static propTypes = {
        account: PropTypes.shape({
            sign_up_errors: PropTypes.object.isRequired,
        }).isRequired,
        actions: PropTypes.shape({
            resendActivationLink: PropTypes.func.isRequired,
            signUp: PropTypes.func.isRequired,
        }).isRequired,
        appState: PropTypes.shape({
            loading: PropTypes.bool.isRequired,
        }).isRequired,
        crew: PropTypes.shape({
            crew_types: PropTypes.array,
        }).isRequired,
        crew_type_actions: PropTypes.shape({
            loadCrewTypes: PropTypes.func.isRequired,
        }).isRequired,
        location: PropTypes.shape({
            countries: PropTypes.array,
        }).isRequired,
        location_actions: PropTypes.shape({
            loadCountries: PropTypes.func.isRequired,
        }).isRequired,
    }

    constructor(props) {
        super(props)

        this.state = {
            data: {
                ref: window.ref || null,
            },
            user: null,
            activationLinkSent: false,
        }

        this.updateValue = formHandler.updateValue.bind(this)
    }

    componentWillMount() {
        if (storage.getItem('authToken')) {
            browserHistory.push('/')
            return
        }

        if (! this.props.crew.crew_types) {
            this.props.crew_type_actions.loadCrewTypes()
        }

        if (! this.props.location.countries) {
            this.props.location_actions.loadCountries()
        }
    }

    signUp = () => {
        this.props.actions.signUp(
            this.state.data,
            (user) => this.setState({ user })
        )
    }

    resendActivationLink = () => {
        if (this.state.user && this.state.user.uuid) {
            this.props.actions.resendActivationLink(this.state.user.uuid)

            // setTimeout means that the browser doesn't see our click on the "resend" link also
            // being a click on the telephone link in the content that replaces it.
            setTimeout(() => {
                this.setState({ activationLinkSent: true })
            }, 200) // eslint-disable-line no-magic-numbers
        }

    }

    render() {
        const errors = this.props.account.sign_up_errors

        const header = (
            <div className="logo">
                <img alt="" src="/img/hayden-logo.png" width="200" />
            </div>
        )

        const subFooter = (
            <div className="text-center">
                <p>Already have an account. <Link to="/sign-in">Login here.</Link></p>
            </div>
        )

        let content = null

        if (this.state.user) {
            if (this.state.activationLinkSent) {
                content = (
                    <div className="align-center">
                        <h3>Thank you for registering with Man With A Cam, Inc.</h3>
                        <p>
                            Your activation link has been re-sent. If you still have not received
                            the link, please contact us on
                            { ' ' }
                            <a href="tel:+16466883447">646-688-3447</a>
                            { ' ' }
                            or email us at
                            { ' ' }
                            <a href="mailto:support@hayden5.com">support@hayden5.com</a>.
                        </p>
                    </div>
                )
            } else {
                content = (
                    <div className="align-center">
                        <h3>Thank you for registering with Man With A Cam, Inc.</h3>
                        <p>
                            Please check your email for our activation link. If you did not receive a
                            link, check your spam folder. If you are still having trouble, click
                            { ' ' }
                            <a onClick={ this.resendActivationLink } style={{ cursor: 'pointer' }}>here</a>
                            { ' ' }
                            to resend the link.
                        </p>
                    </div>
                )
            }
        } else {
            content = (
                <div>
                    <p className="align-center">Please enter your details below and choose a password.</p>
                    <TextInput
                        error={ errors.full_name }
                        name="full_name"
                        placeholder="First & Last Name"
                        type="text"
                        updateValue={ this.updateValue }
                        value={ this.state.data.full_name }
                    />
                    <TextInput
                        error={ errors.email }
                        name="email"
                        placeholder="Email"
                        type="email"
                        updateValue={ this.updateValue }
                        value={ this.state.data.email }
                    />
                    <TextInput
                        error={ errors.password }
                        name="password"
                        placeholder="Choose a password"
                        type="password"
                        updateValue={ this.updateValue }
                        value={ this.state.data.password }
                    />
                    <Select
                        error={ errors.country }
                        name="country"
                        options={ this.props.location.countries }
                        placeholder="Select your country"
                        updateValue={ this.updateValue }
                        value={ this.state.data.country }
                    />
                    <Select
                        categoriseBy="category.label"
                        error={ errors.crew_type }
                        name="crew_type"
                        options={ this.props.crew.crew_types }
                        placeholder="Primary crew type"
                        updateValue={ this.updateValue }
                        value={ this.state.data.crew_type }
                    />
                    <Button
                        fullWidth
                        loading={ this.props.appState.loading }
                        onClick={ this.signUp }
                        status="primary"
                    >
                        Sign up
                    </Button>
                </div>
            )
        }

        return (
            <Dialog
                allowClose={ false }
                background={ false }
                header={ header }
                open
                size="small"
                subFooter={ subFooter }
            >
                { content }
            </Dialog>
        )
    }
}



// WEBPACK FOOTER //
// ./app/components/account/sign_up.js